<template>
  <div class="adj-pament-container">
    <span class="adj-pament-title">付费明细</span>
    <div class="adj-pament-line"></div>
    <div
      :class="{
        feeTip: true,
        infoTip: info.status === 0 || info.status === 1,
        errorTip: info.status === 3 || info.status === 4
      }"
      v-if="info.status !== 2"
    >
      <div class="icon-tip"></div>
      <div v-if="info.status === 0" class="msg-tip">
        您暂不具有发布收费点金的资格，您可以
        <router-link class="apply" to="payment/apply">立即申请</router-link>
      </div>
      <div v-else-if="info.status == 1" class="msg-tip">
        您发布收费点金的资格正在审核中，请耐心等待。
      </div>
      <div v-else-if="info.status === 3" class="msg-tip">
        您发布收费点金的资格申请已被拒绝，现在可以<router-link class="apply" to="payment/apply">再次申请</router-link>。
      </div>
      <div v-else-if="info.status == 4" class="msg-tip">
        您发布收费点金的资格已关闭，如有疑问请联系客服400-602-1010。
      </div>
    </div>
    <div class="adj-pament-content">
      <div class="adj-pament-block">
        <span class="adj-block-name">单价：元</span>
        <span class="adj-block-val">{{ info.price.toFixed(2) }}</span>
      </div>
      <div class="adj-pament-block">
        <span class="adj-block-name">当前服务人数</span>
        <span class="adj-block-val">{{ info.serviceNum }}</span>
      </div>
      <div class="adj-pament-block">
        <span class="adj-block-name">已到期</span>
        <span class="adj-block-val">{{ info.expiredCount }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { getAuthorStatistics } from '@/api/dianjin'
export default {
  name: 'Pament',
  data() {
    return {
      info: {
        expiredCount: 0,
        serviceNum: 0,
        totalIncome: 0,
        price: 0,
        status: 0 // 0.初始状态(为提交申请) 1.等待审核 2.已拒绝 3.已关闭
      }
    }
  },
  methods: {
    async getAuthorStatistics() {
      const { result, detail } = await getAuthorStatistics()
      if (result.code === 0) {
        this.info = detail
      } else {
        this.$notify.error({
          position: 'bottom-right',
          title: '错误',
          message: '数据请求发生异常，请稍后再试。'
        })
      }
    }
  },
  created() {
    this.getAuthorStatistics()
  }
}
</script>

<style lang="scss" scoped>
.adj-pament-container {
  display: flex;
  flex-direction: column;
  border-radius: 5px;
  background-color: #ffffff;
  padding: 25px 50px;
  height: 580px;
  .adj-pament-title {
    height: 45px;
    font-family: MicrosoftYaHei;
    font-size: 20px;
    font-weight: bold;
    font-stretch: normal;
    line-height: 40px;
    letter-spacing: 0px;
    color: #262626;
  }
  .adj-pament-line {
    width: 766px;
    height: 1px;
    background-color: #ebebeb;
  }
  .adj-pament-content {
    display: flex;
    justify-content: space-between;
    .adj-pament-block {
      width: 222px;
      height: 120px;
      background-color: #fafafa;
      border-radius: 5px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      margin: 30px 0;
      .adj-block-name {
        font-family: MicrosoftYaHei;
        font-size: 14px;
        font-weight: normal;
        font-stretch: normal;
        line-height: 14px;
        letter-spacing: 0px;
        color: #858585;
      }
      .adj-block-val {
        font-family: MicrosoftYaHei;
        font-size: 20px;
        font-weight: bold;
        font-stretch: normal;
        line-height: 44px;
        letter-spacing: 0px;
        color: #262626;
      }
    }
  }
}
.feeTip {
  margin-top: 30px;
  height: 40px;
  line-height: 40px;
  border-radius: 4px;
  font-family: MicrosoftYaHei;
  font-size: 14px;
  letter-spacing: 0px;
  display: flex;
  align-items: center;
  padding: 0px 20px;
  color: #262626;
}

.infoTip .msg-tip {
  flex: auto;
}

.errorTip .msg-tip {
  flex: auto;
}

.infoTip {
  background-color: rgba(4, 107, 204, 0.1);
}
.errorTip {
  background-color: rgba(230, 76, 46, 0.1);
}

.infoTip .icon-tip {
  background-image: url('~@/assets/images/icons/info2x.png');
  width: 20px;
  height: 20px;
  background-size: 20px;
  margin-right: 10px;
}
.errorTip .icon-tip {
  background-image: url('~@/assets/images/icons/error2x.png');
  width: 20px;
  height: 20px;
  margin-right: 10px;
  background-size: 20px;
}
.apply {
  font-family: MicrosoftYaHei;
  font-size: 14px;
  font-weight: bold;
  letter-spacing: 0px;
  color: #046bcc;
  text-decoration: none;
}
</style>
